import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material'
import {
  selectToggleConfirmationDialog,
  resolveConfirmation,
} from '../store/slices/notificationsSlice'

const ConfirmationDialog = () => {
  const open = useSelector(selectToggleConfirmationDialog)
  const dispatch = useDispatch()

  const handleConfirm = () => {
    dispatch(resolveConfirmation(true))
  }

  const handleCancel = () => {
    dispatch(resolveConfirmation(false))
  }

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title">
        Confirm Deletion
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          Are you sure you want to delete this entry? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog